import { ManagedUser } from "./managed-user.model";

export class GrantUserAccess {
    constructor(public basicUser: ManagedUser, public userForAccess: ManagedUser) {
        this.basicUser = basicUser;
        this.userForAccess = userForAccess;
    }
}